export var TubeConnectionId;
(function (TubeConnectionId) {
    TubeConnectionId["THREE_WAY_T"] = "3T";
    TubeConnectionId["THREE_WAY_Y"] = "3Y";
    TubeConnectionId["TWO_WAY_90"] = "90";
    TubeConnectionId["FOUR_WAY_X"] = "4X";
    TubeConnectionId["FOUR_WAY_TT"] = "2x3T";
    TubeConnectionId["FOUR_WAY_TT_ALTERNATE"] = "2x3T_Alt";
    TubeConnectionId["FOUR_WAY_TT_ALTERNATE_MIRROR"] = "2x3T_Alt_Mir";
    TubeConnectionId["TOOL_CHANGER"] = "TC";
    TubeConnectionId["ONE_FOUR_FIVE_DISTRIBUTION_BLOCK"] = "1-4-5";
    TubeConnectionId["ONE_SIX_SEVEN_DISTRIBUTION_BLOCK"] = "1-6-7";
    TubeConnectionId["ONE_EIGHT_NINE_DISTRIBUTION_BLOCK"] = "1-8-9";
    TubeConnectionId["ONE_TEN_ELEVEN_DISTRIBUTION_BLOCK"] = "1-10-11";
})(TubeConnectionId || (TubeConnectionId = {}));
export { ObjectShapeId, TubeType, GripPositionMarkerId, NodeComponentType, GlassObjectShapeId, PlasticObjectShapeId, MetalObjectShapeId, CardboardObjectShapeId, } from "./types.v6";
